// Strings for code that runs outside the React tree (the API client, the auth
// context). Read them with translate() from i18n/translate.js.
const shell = {
  en: {
    errors: {
      forbidden: "You don't have permission to view this.",
      rateLimited: 'Too many requests — please wait a moment and try again.',
      serverUnavailable: 'The server is temporarily unavailable. Please try again shortly.',
      timeout: 'The server took too long to respond. Please try again.',
      network: 'Cannot reach the server. Check your connection and try again.',
      requestFailed: 'Request failed',
      serverError: 'Something went wrong on the server. Please try again shortly.',
      notFound: "We couldn't find what you asked for. It may have been deleted.",
      invalidInput: 'Some details are not filled in correctly. Check the fields and try again.',
      alreadyExists: 'This record already exists.',
    },
    session: {
      expiring: 'Your session is about to expire. Sign in again to keep working.',
    },
  },
  ru: {
    errors: {
      forbidden: 'У вас нет прав для просмотра этого.',
      rateLimited: 'Слишком много запросов — подождите немного и повторите попытку.',
      serverUnavailable: 'Сервер временно недоступен. Повторите попытку чуть позже.',
      timeout: 'Сервер слишком долго не отвечает. Повторите попытку.',
      network: 'Нет связи с сервером. Проверьте подключение и повторите попытку.',
      requestFailed: 'Не удалось выполнить запрос',
      serverError: 'На сервере произошла ошибка. Повторите попытку чуть позже.',
      notFound: 'Запрошенные данные не найдены. Возможно, они были удалены.',
      invalidInput: 'Данные заполнены неверно. Проверьте поля и повторите попытку.',
      alreadyExists: 'Такая запись уже существует.',
    },
    session: {
      expiring: 'Ваш сеанс скоро истечёт. Войдите снова, чтобы продолжить работу.',
    },
  },
  uz: {
    errors: {
      forbidden: "Buni ko'rish uchun ruxsatingiz yo'q.",
      rateLimited: "So'rovlar juda ko'p — biroz kuting va qayta urinib ko'ring.",
      serverUnavailable: "Server vaqtincha ishlamayapti. Birozdan so'ng qayta urinib ko'ring.",
      timeout: "Server javob berishga juda uzoq vaqt oldi. Qayta urinib ko'ring.",
      network: "Serverga ulanib bo'lmadi. Internet aloqasini tekshirib, qayta urinib ko'ring.",
      requestFailed: "So'rovni bajarib bo'lmadi",
      serverError: "Serverda xatolik yuz berdi. Birozdan so'ng qayta urinib ko'ring.",
      notFound: "So'ralgan ma'lumot topilmadi. U o'chirilgan bo'lishi mumkin.",
      invalidInput: "Ma'lumotlar to'g'ri kiritilmagan. Maydonlarni tekshirib, qayta urinib ko'ring.",
      alreadyExists: 'Bunday yozuv allaqachon mavjud.',
    },
    session: {
      expiring: "Seansingiz tez orada tugaydi. Ishni davom ettirish uchun qayta kiring.",
    },
  },
};

export default shell;
